module.exports = __webpack_public_path__ + "static/region_occitanie-752a4ba51c0b3025636a2da4a18aef83.png";